module.exports = __webpack_public_path__ + "static/media/arrowUp.57767b12.svg";